import React, {Component} from 'react';
import {
    TextField,
    Dialog,
    DialogContent,
    FormControl,
    InputLabel,
    Input,
    Icon,
    Button,
    IconButton,
    Typography,
    DialogActions,
    Toolbar,
    AppBar,
    InputAdornment,
    Tooltip
} from '@material-ui/core';
import {Visibility, VisibilityOff} from '@material-ui/icons';
import {ToggleButton, ToggleButtonGroup} from '@material-ui/lab';
import {withStyles} from '@material-ui/core/styles/index';
import {bindActionCreators} from 'redux';
import {UecareDropdown, UecareInput} from '../../../../components';
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import ReduxGroup from '../../../../store/actionreducers/group';
import ReduxVip from '../../../../store/actionreducers/vip';
import VipService from '../../../../service/vip';
import UecareAvatarUpload from "../../../../components/UecareAvatarUpload";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {connect} from 'react-redux';
import classNames from 'classnames';
import moment from 'moment';
import _ from 'lodash';
import {constDataDialogs} from "../../../../constants";
import {account_status} from "../../../../constants/status";

const styles = theme => ({
    root: {},
    button: {
        margin: theme.spacing.unit,
    },
    addressButton: {
        margin: theme.spacing.unit * 1 / 2,
    },
    formControl: {
        marginBottom: 24
    },
});

const initNewVipState = {
    group: {
        type: {
            name: ''
        }
    },
    user: {
        family_name: '',
        given_name: '',
        nickname: '',
        cell_phone_no: '',
        backup_phone: '',
        id_no: '',
        email: '',
        password: '',
        sex: '',
        birthday: moment().format('YYYY-MM-DD'),
        avatar: {url: 'https://res.cloudinary.com/uecare/image/upload/v1524205226/DefaultImage/vipHead_3x.png'},
    },
    visit_address: {
        city: {id: 1, name: '台北市'},
        address: '',
        status: {id: 24, label: 'applying'}
    },
    habit: '',
    ill_history: ''
};

const initControllerState = {
    show_password: false,
    is_password_edited: false,
    groupType: {label: 'person'},
    group_first_vip: '否'
};

class VipDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {vip: initNewVipState, ...initControllerState};
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        /**
         * no vipDialog , no data need to resolve
         */
        if (!this.props.vipDialog) return;

        /**
         * After Dialog Open
         */
        if (!prevProps.vipDialog || (!prevProps.vipDialog.props.open && this.props.vipDialog.props.open)) {

            /**
             * Dialog type: 'edit'
             * Update State
             */
            if (this.props.vipDialog.type === 'edit' &&
                this.props.vip &&
                !_.isEqual(this.props.vip, prevState.vip)) {

                const groupType = this.props.groupTypes.find((groupType) => {
                    return groupType.id === this.state.vip.group.type.id;
                });

                this.setState({
                    vip: this.props.vip, ...initControllerState,
                    groupType: groupType || this.props.personGroupType,
                    group: this.props.vip.group,
                    company: this.props.vip.group && this.props.vip.group.company,
                });
            }

            /**
             * Dialog type: 'new'
             * Update State
             */
            if (this.props.vipDialog.type === 'new') {
                _.set(initNewVipState, 'user.name', initNewVipState.user.family_name + initNewVipState.user.given_name);
                this.setState({vip: initNewVipState, ...initControllerState});
            }
        }
    }

    _getGroupTypeId = () => {
        if (this.state.groupType && this.state.groupType.id) return this.state.groupType.id;
        if (this.state.vip.group.type && this.state.vip.group.type.id) {
            const groupType = this.props.groupTypes.find((groupType) => {
                return groupType.id === this.state.vip.group.type.id;
            });
            if (groupType) return groupType.id; // 確認取到的 groupType 有在 groupType list 中
        }

        if (this.props.personGroupType && this.props.personGroupType.id) return this.props.personGroupType.id;
        return 0;
    };

    _getGroups = () => {
        if (this.state.groupType.label === 'company' && this.state.company) {
            return this.props.groups.filter((group) => {
                return group.company && (group.company.id === this.state.company.id);
            });
        } else return this.props.groups.filter((group) => {
            return group.type.label === this.state.groupType.label;
        });
    };

    handleClickShowPassword = () => {
        const password = (this.state.is_password_edited) ? this.state.vip.user.password : '';
        this.setState(state => ({
            show_password: !state.show_password,
            is_password_edited: true,
            vip: {...this.state.vip, user: {...this.state.vip.user, password}}
        }));
    };

    handleClickYesNo = (name, value) => {
        this.setState({[name]: value});
    };

    handleDropDownChange = (name, value) => {
        this.setState({[name]: value});
    };

    handleVipChange = (event) => {
        const newVip = {...this.state.vip, [event.target.name]: event.target.value};
        this.setState({vip: newVip});
    };

    handleChange = (event) => {
        const newVip = {...this.state.vip, user: {...this.state.vip.user, [event.target.name]: event.target.value}};
        const is_password_edited = (event.target.name === 'password') ? true : this.state.is_password_edited;
        newVip.user.name = newVip.user.family_name + newVip.user.given_name;
        this.setState({vip: newVip, is_password_edited});
    };

    closeDataDialog = () => {
        this.props.closeDataDialog({name: constDataDialogs.name.vipDialog});
    };

    _updateMainVip = async (vip, group) => {
        const updateGroupMainVip = this.props.updateGroupMainVip;
        if (this.state.group_first_vip === '是' && this.state.groupType.label !== 'person') {
            try {
                await updateGroupMainVip(vip, group);
            } catch (e) {
                console.warn('you got an error = ', e);
            }
        }
    };

    _isBlank(str) {
        return (!str || /^\s*$/.test(str));
    }

    _getDialogAction() {

        const {openLoadingMask, closeLoadingMask, vipDialog, addVip, updateVip, refreshVips, vipChangePassword, disableVip} = this.props;

        const addButton = (
            <Button
                variant="raised"
                color="primary"
                disabled={!this.canBeSubmitted()}
                onClick={async () => {
                    try {
                        openLoadingMask();
                        const vip = await addVip(this.state.vip);

                        if (this.state.group_first_vip === '是') {
                            const group = this.state.vip.group;
                            await this._updateMainVip(vip, group);
                        }

                        await refreshVips();
                        closeLoadingMask();
                        this.closeDataDialog();
                    } catch (e) {
                        console.warn('you got an error = ', e);
                    }
                }}
            >
                新增
            </Button>
        );

        const updateButton = (
            <Button
                variant="raised"
                color="primary"
                onClick={async () => {

                    try {
                        openLoadingMask();

                        const user = {
                            email: this.state.vip.user.email,
                            family_name: this.state.vip.user.family_name,
                            given_name: this.state.vip.user.given_name,
                            id_no: this.state.vip.user.id_no,
                            birthday: this.state.vip.user.birthday,
                        }

                        const visit_address = {
                            city: this.state.vip.visit_address.city,
                            address: this.state.vip.visit_address.address,
                        }
                        const vip = {
                            id: this.state.vip.id,
                            user,
                            visit_address
                        }

                        const editVip = await updateVip(vip);

                        if (this.state.group_first_vip === '是') {
                            const group = this.state.vip.group;
                            await this._updateMainVip(editVip, group);
                        }

                        if (this.state.is_password_edited) {
                            await vipChangePassword({
                                vipId: editVip.id,
                                password: this.state.vip.user.password
                            });
                        }

                        await refreshVips();
                        closeLoadingMask();
                        this.closeDataDialog();
                    } catch (e) {
                        console.warn('you got an error = ', e);
                    }
                }}
            >
                修改
            </Button>
        );

        const disableButton = (
            <Tooltip title="停用">
                <IconButton
                    onClick={async () => {
                        try {
                            await disableVip(this.state.vip.id); // disable VIP
                            await refreshVips();
                            this.closeDataDialog();
                        } catch (e) {
                            console.warn('you got an error = ', e);
                        }
                    }}
                >
                    <Icon>not_interested</Icon>
                </IconButton>
            </Tooltip>
        );

        const reSendValidateEMailButton = (
            <Tooltip title="重寄開通信件">
                <IconButton
                    style={{color: '#1896D1'}}
                    onClick={async () => {
                        try {
                            openLoadingMask();
                            const email = this.state.vip.user.email;
                            await VipService.reSendValidateEMail({email});
                            await refreshVips();
                            closeLoadingMask();
                            this.closeDataDialog();
                        } catch (e) {
                            console.warn('you got an error = ', e);
                        }
                    }}
                >
                    <Icon>drafts</Icon>
                </IconButton>
            </Tooltip>
        );

        const directEnableButton = (
            <Tooltip title="直接開通">
                <IconButton
                    style={{color: '#851684'}}
                    disabled={!this.canBeSubmitted()}
                    onClick={async () => {
                        try {
                            openLoadingMask();
                            const vipId = this.state.vip.id;
                            await VipService.enable(vipId);
                            await refreshVips();
                            closeLoadingMask();
                            this.closeDataDialog();
                        } catch (e) {
                            console.warn('you got an error = ', e);
                        }
                    }}
                >
                    <Icon>how_to_reg</Icon>
                </IconButton>
            </Tooltip>
        );

        const emptyButton = (
            <IconButton disabled/>
        );

        if (vipDialog.type === 'new') {
            return (
                <DialogActions className="justify-between pl-16">
                    {addButton}
                </DialogActions>
            );
        } else {
            return (
                <DialogActions className="justify-between pl-16">
                    {updateButton}
                    {(this.state.vip.status && this.state.vip.status.label === account_status.registered.label) ? reSendValidateEMailButton : emptyButton}
                    {(this.state.vip.status && this.state.vip.status.label === account_status.tocheck.label) ? directEnableButton : emptyButton}
                    {(this.state.vip.status && this.state.vip.status.label === account_status.activated) ? disableButton : emptyButton}
                </DialogActions>
            );
        }

    }

    canBeSubmitted() {
        const { groupType, company, group, vip } = this.state
        if (groupType.label === 'company') {
            if (!company) return false
            if (!group) return false
        } else if (groupType.label === 'family') {
            if (!group) return false
        }

        return !this._isBlank(vip.user.name) && !this._isBlank(vip.user.password);
    }

    render() {
        const {classes, cities, vipDialog, vipAvatarGetUrl, vipEnableVisitAddress} = this.props
        if (!vipDialog || vipDialog.props.open === false) return <div/>
        const { vip } = this.state

        return (
            <Dialog className={classes.root} {...vipDialog.props} onClose={this.closeDataDialog} fullWidth
                    maxWidth="xs">

                <AppBar position="static">
                    <Toolbar className="flex w-full">
                        <Typography variant="subheading" color="inherit">
                            {vipDialog.type === 'new' ? '建立會員帳號' : '會員資料'}
                        </Typography>
                    </Toolbar>
                    <div className="flex flex-col items-center justify-center pb-24">
                        <UecareAvatarUpload
                            className="w-96 h-96"
                            src={vip.user.avatar
                                ? vip.user.avatar.url
                                : "https://res.cloudinary.com/uecare/image/upload/v1524205226/DefaultImage/vipHead_3x.png"}
                            onClick={async (base64Image) => {
                                try {
                                    const avatar = await vipAvatarGetUrl({base64Image});
                                    this.handleChange({target: {name: 'avatar', value: avatar}});
                                } catch (e) {
                                    console.warn('you got an error = ', e);
                                }
                            }}/>
                        {vipDialog.type === 'edit' && (
                            <Typography variant="title" color="inherit" className="pt-8">
                                {vip.user.name}
                            </Typography>
                        )}
                    </div>
                </AppBar>

                <DialogContent classes={{root: "p-24"}} autoComplete="new-password">

                    <UecareInput
                        label='Email'
                        icon='email'
                        name='email'
                        id='email'
                        className={classes.formControl}
                        value={this.state.vip.user.email}
                        onChange={this.handleChange}/>

                    <div className="flex">
                        <div className="min-w-48 pt-20">
                            <Icon color="action">lock</Icon>
                        </div>
                        <FormControl className={classes.formControl} fullWidth>
                            <InputLabel htmlFor="password">密碼</InputLabel>
                            <Input
                                id="password"
                                name="password"
                                type={this.state.show_password ? 'text' : 'password'}
                                value={this.state.vip.user.password || ''}
                                onChange={this.handleChange}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="Toggle password visibility"
                                            onClick={this.handleClickShowPassword}
                                        >
                                            {this.state.show_password ? <Visibility/> : <VisibilityOff/>}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                    </div>

                    <UecareInput
                        label='姓'
                        icon='account_circle'
                        name='family_name'
                        id='family_name'
                        className={classes.formControl}
                        value={this.state.vip.user.family_name || ''}
                        onChange={this.handleChange}/>

                    <UecareInput
                        label='名'
                        name='given_name'
                        id='given_name'
                        className={classes.formControl}
                        value={this.state.vip.user.given_name || ''}
                        onChange={this.handleChange}/>

                    <UecareInput
                        label='手機號碼'
                        icon='phone'
                        name='cell_phone_no'
                        id='cell_phone_no'
                        className={classes.formControl}
                        value={ (this.state.vip.user.phone_number
                                    && `${this.state.vip.user.phone_country_code} ${this.state.vip.user.phone_number}`)
                                || this.state.vip.user.cell_phone_no
                                || ''}
                        onChange={this.handleChange}/>

                    <UecareInput
                        label='統一證號'
                        icon='picture_in_picture'
                        name='id_no'
                        id='id_no'
                        className={classes.formControl}
                        value={this.state.vip.user.id_no || ''}
                        onChange={this.handleChange}/>

                    <UecareDropdown
                        label='探視縣市'
                        icon='place'
                        name='visit_address_city'
                        id='visit_address_city'
                        className={classes.formControl}
                        value={(this.state.vip.visit_address && this.state.vip.visit_address.city) ? this.state.vip.visit_address.city.id : 0}
                        options={cities}
                        onChange={(event, selectedOption) => {
                            this.handleVipChange({
                                target: {
                                    name: 'visit_address',
                                    value: {city: selectedOption, status: {label: 'applying'}}
                                }
                            });
                        }}/>


                    <div className="flex">
                        <div className="min-w-48 pt-20"/>
                        <FormControl className={classes.formControl} fullWidth>
                            <span className="flex justify-between">
                            <InputLabel>探視地址</InputLabel>
                            <Input
                                id='visit_address'
                                name='visit_address'
                                className={'w-full'}
                                value={this.state.vip.visit_address && this.state.vip.visit_address.address || ''}
                                onChange={(event) => {
                                    this.handleVipChange({
                                        target: {
                                            name: 'visit_address',
                                            value: {
                                                city: this.state.vip.visit_address.city,
                                                address: event.target.value
                                            }
                                        }
                                    });
                                }}/>
                            </span>
                        </FormControl>
                    </div>

                    <UecareInput
                        label='習慣'
                        icon='favorite'
                        name='habit'
                        id='habit'
                        className={classes.formControl}
                        value={vip.habit || ''}
                        onChange={this.handleVipChange}/>

                    <UecareInput
                        label='病史'
                        icon='assignment'
                        name='ill_history'
                        id='ill_history'
                        className={classes.formControl}
                        value={vip.ill_history || ''}
                        onChange={this.handleVipChange}/>


                    <div className="flex">
                        <div className="min-w-48 pt-20">
                            <Icon color="action">wc</Icon>
                        </div>
                        <FormControl className={classes.formControl} fullWidth>
                            <InputLabel htmlFor="sex">性別</InputLabel>
                            <Input id="sex" name="sex" value={vip.user.sex} disabled/>
                        </FormControl>
                        <ToggleButtonGroup exclusive value={vip.user.sex} onChange={this.handleChange}>
                            <ToggleButton value={{target: {name: 'sex', value: '男'}}}>
                                <FontAwesomeIcon icon="male"/>
                            </ToggleButton>
                            <ToggleButton value={{target: {name: 'sex', value: '女'}}}>
                                <FontAwesomeIcon icon="female"/>
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </div>

                    <div className="flex">
                        <div className="min-w-48 pt-20">
                            <Icon color="action">cake</Icon>
                        </div>
                        <TextField
                            id="birthday"
                            name="birthday"
                            label="生日"
                            type="date"
                            className={classes.formControl}
                            InputLabelProps={{
                                shrink: true
                            }}
                            value={this.state.vip.user.birthday}
                            onChange={this.handleChange}
                        />
                    </div>

                </DialogContent>

                {this._getDialogAction()}

            </Dialog>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        addVip: ReduxVip.ActionCreator.addVip,
        refreshVips: ReduxVip.ActionCreator.refreshVips,
        updateVip: ReduxVip.ActionCreator.updateVip,
        vipChangePassword: ReduxVip.ActionCreator.changePassword,
        vipAvatarGetUrl: ReduxVip.ActionCreator.avatarGetUrl,
        vipEnableVisitAddress: ReduxVip.ActionCreator.enableVisitAddress,
        disableVip: ReduxVip.ActionCreator.disableVip,
        updateGroupMainVip: ReduxGroup.ActionCreator.updateMainVip,
        closeDataDialog: ReduxGlobal.ActionCreator.closeDataDialog,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
    }, dispatch);
}

function mapStateToProps({global: {dataDialog, dataDialogs}, city: {cities}, group: {groups}, company: {companies}, vip: {vip}, groupType}) {

    const personGroupType = groupType.list.find((groupType) => {
        return groupType.label === 'person';
    });

    return {
        vipDialog: dataDialogs[constDataDialogs.name.vipDialog],
        dataDialog,
        groups,
        companies,
        vip,
        cities,
        groupTypes: groupType.list,
        personGroupType
    }
}

export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(VipDialog));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/vip/VipDialog.js